<template>
  <div class="w-full flex flex-wrap px-4 py-2">
    <div class="w-full text-right">
      <a class="cursor-pointer px-4 py-2" @click="$emit('close')">
        <font-awesome-icon :icon="['fas', 'times']" />
      </a>
    </div>

    <div class="w-full" v-if="!processed">
      <month-picker-input
        :default-month="new Date().getMonth() + 1"
        :default-year="new Date().getFullYear()"
        :input-pre-filled="true"
        v-model="data.month"
      ></month-picker-input>

      <div class="w-full mb-4">Click the button</div>

      <div class="w-full mt-2">
        <b-button @click="submit">Generate</b-button>
      </div>
    </div>

    <div class="w-full" v-else>
      <div class="w-full" v-if="!created.length">
        <p class="mb-2">No new items were generated. All settings currently have an item for the month of {{ data.month.monthIndex }} / {{ data.month.year }}.</p>
        <p class="mb-2">If this was not the desired result, please delete the corresponding item(s) and try to generate again.</p>
      </div>

      <div class="w-full" v-else>
        <p class="mb-2">The following item(s) were generated for the month of {{ data.month.monthIndex }} / {{ data.month.year }}.</p>

        <ol class="mb-2 ml-4 list-decimal">
          <li
            class="pl-2"
            v-for="item in created" :key="item.id"
          >
            {{ company(item) }} <span class="text-sm">{{ filter(item) }}</span>
          </li>
        </ol>

        <p class="mb-2">If this was not the desired result, please delete the corresponding item(s) and try to generate again.</p>
      </div>

      <div class="w-full mt-2">
        <b-button @click="$emit('close')">Close</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { MonthPickerInput } from "vue-month-picker"
import { EventBus } from "../events"
import {map} from 'lodash'

export default {
  name: "GeneratePeriodsForm",
  components: {
    MonthPickerInput,
  },
  data() {
    return {
      data: {
        month: {
          monthIndex: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
        },
      },
      created: [],
      processed: false,
    }
  },
  methods: {
    company(item) {
      return map(item.companies, (i) => i.name).join(", ")
    },
    filter(item) {
      if (!item.campaign_filter) return null
      if (item.campaign_filter_operator === "contains")
        return '(only "' + item.campaign_filter + '")'
      else return '(not "' + item.campaign_filter + '")'
    },
    async submit() {
      EventBus.$emit("loading:start")

      await this.axios
        .get("budget/period/create?month=" + this.data.month.year + "-" + this.data.month.monthIndex)
        .then(({ data }) => {
          this.created = data.created
          EventBus.$emit("fetch-settings")
        })

      EventBus.$emit("loading:stop")
      this.processed = true
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
